/**
 * push-tokens.ts — Chunk 153: Mobile Push Token API client
 *
 * Manages FCM/APNs device tokens via the auth service push-tokens endpoints.
 */

import apiClient from './client';

export type PushTokenPlatform = 'ios' | 'android' | 'web';

export interface PushToken {
  id: string;
  user_id: string;
  token: string;
  platform: PushTokenPlatform;
  device_label: string | null;
  registered_at: string;
  last_seen_at: string;
}

export interface RegisterPushTokenInput {
  token: string;
  platform: PushTokenPlatform;
  device_label?: string;
}

/**
 * POST /push-tokens/:userId
 * Register (or refresh) a device push token.
 */
export async function registerPushToken(
  userId: string,
  input: RegisterPushTokenInput
): Promise<PushToken> {
  const res = await apiClient.post<{ pushToken: PushToken }>(`/push-tokens/${userId}`, input);
  return res.data.pushToken;
}

/**
 * GET /push-tokens/:userId
 * List all registered push tokens for the user.
 */
export async function listPushTokens(userId: string): Promise<PushToken[]> {
  const res = await apiClient.get<{ pushTokens: PushToken[] }>(`/push-tokens/${userId}`);
  return res.data.pushTokens;
}

/**
 * DELETE /push-tokens/:userId/:tokenId
 * Remove a registered push token.
 */
export async function deletePushToken(userId: string, tokenId: string): Promise<void> {
  await apiClient.delete(`/push-tokens/${userId}/${tokenId}`);
}
